import { render, staticRenderFns } from "./RaffleTermWarning.vue?vue&type=template&id=3bb42745"
import script from "./RaffleTermWarning.vue?vue&type=script&lang=js"
export * from "./RaffleTermWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports